import React from 'react';
import AppRoutes from 'router/AppRouter';
import { BrowserRouter } from 'react-router-dom';
import ScrollToHash from 'pages/ScrollHash';
import 'App.css';

function App() {

  return (
      <BrowserRouter>
       <ScrollToHash />
        <AppRoutes />
      </BrowserRouter>
  );
}
export default App;
